<template>
  <div class="component-content configuration-stem">

    <div class="component-content-scroll">
      <div class="component-content-title mb-3">Select your stem</div>
    <option-list
      :options="stemInput"
      :inputName="'stem'"
      :target="this.results.stem"
      :targetMeasure="this.measures.stem"
      :measures="measures"
      :measureLabel="'Set stem length'"
      :results="results"
      v-on:target-updated="updateData"
      v-on:update-measures="setMeasure"
    ></option-list>

    <div class="color-selector mt-4 pt-2" v-if="showColorSelector()">
      <ColorSelector
        :primaryColor="results.colour.primaryColor"
        :secondaryColor="results.colour.secondaryColor"
        :colors="colors"
        :componentId="this.results.stem.id"
        :componentType="'stem'"
        :results="results"
        v-on:component-color-selected="selectColor"
      ></ColorSelector>
    </div>
    </div>
    <div class="buttonset">
      <button class="btn btn-outline-dark back-button" v-on:click="goBack">
        back
      </button>
      <finish-configuration-button
        v-if="canFinishConfiguration()"
        v-on:finish-configuration="finishConfiguration"
       ></finish-configuration-button>
      <button class="btn btn-outline-dark next-button" v-on:click="goNext">
        next
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import OptionList from "../../shared/optionList.vue";
import ColorSelector from "../../shared/component-color-selector.vue";
import FinishConfigurationButton from './finish-configuration-button.vue';

Vue.component("finish-configuration-button", FinishConfigurationButton);

export default {
  name: "configuration-stem",
  data() {
    return {};
  },
  components: {
    OptionList,
    ColorSelector,
  },
  props: [
    "configuratorSteps",
    "currentStep",
    "results",
    "components",
    "measures",
    "colors",
    "bike",
  ],
  methods: {
    goNext: function () {
      if (this.results.stem == null) {
        this.$emit("set-error", "Please select a stem");
        return false;
      }
      if (
        this.results.stem != null &&
        this.results.stem.id != -1 &&
        this.results.stem.measure == null
      ) {
        this.$emit("set-error", "Please select a stem measure");
        return false;
      }
      if (
        this.showColorSelector() &&
        typeof this.results.stem.colour == 'undefined' &&
        this.results.stem.colour == null
      ) {
        this.$emit("set-error", "Please select a stem colour");
        return false;
      }
      this.$emit("go-next");
    },
    goBack: function () {
      this.$emit("go-back");
    },
    filter: function (brand) {
      const options = this.components.stem?.[0];
      if (!options) {
        return [];
      }
      return options.filter(function (e) {
        if (e.brand == brand) {
          return e;
        }
      });
    },
    updateData: function (e) {
      if (this.results.handlebars != null &&
      this.results.handlebars.id == 40){
        return false;
      }
      this.stemInput = e;
    },
    setMeasure: function (measure) {
      this.measuresInput = measure;
    },
    getMeasure: function () {
      if (this.results.stem != null) {
        return this.results.stem.measure;
      }
      return null;
    },
    showColorSelector: function () {
      if (
        typeof this.results.stem != "undefined" &&
        this.results.stem != null &&
        this.results.stem.is_paintable == 1 &&
        typeof this.results.stem.measure != 'undefined' &&
        this.results.colour.primaryColor != null &&
        //this.results.colour.secondaryColor != null &&
        //this.results.stem.id != 14 &&
        this.results.stem.id != -1 &&
        this.bike.id != 32
      ) {
        //console.log(['this.results.stem != "undefined"','this.results.stem != null','this.results.stem.is_paintable == 1','this.results.stem.measure != undefined','this.results.colour.primaryColor != null,this.results.stem.id != -1']);
        //console.log([this.results.stem != "undefined",this.results.stem != null,this.results.stem.is_paintable == 1,this.results.stem.measure != "undefined",this.results.colour.primaryColor != null,this.results.stem.id != -1])
        return true;
      }
      return false;
    },
    selectColor: function (color, componentId, componentType) {
      this.$emit("component-color-selected", color, componentId, componentType);
    },
    canFinishConfiguration: function() {
// if fork is present, we need to check if the fork is selected and has a colour
        if (this.components.fork?.length > 0)
        {
          return (
          this.results.frame !== null &&
          this.results.frame !== undefined &&
          this.results.colour !== null &&
          this.results.colour !== undefined &&
          this.results.fork !== null &&
          this.results.fork !== undefined
          );
        }
        else
        {
          // no fork, so we can finish configuration
          return (
            this.results.frame !== null &&
            this.results.frame !== undefined &&
            this.results.colour !== null &&
            this.results.colour !== undefined
          );
        }
    },
    finishConfiguration: function() {
        this.$emit("finish-configuration");
    },
  },
  computed: {
    getBrands: function () {
      const options = this.components.stem?.[0];
      if (!options) {
        return [];
      }
      return options.map(function (e) {
        return e.brand;
      });
    },
    stemInput: {
      get: function () {
        return this.components.stem?.[0] ?? [];
      },
      set: function (e) {
        this.$emit("set-stem", e);
      },
    },
    measuresInput: {
      get: function () {
        if (
          this.results.stem == null ||
          typeof this.results.stem.measure == "undefined"
        ) {
          return null;
        }
        return this.results.stem.measure;
      },
      set: function (e) {
        this.$emit("set-measure", "stem", e);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.configuration-stem {
}
</style>